import { createRootRoute, createRoute, createRouter } from "@tanstack/react-router";
import { Layout } from "./components/Layout";
import { Listings } from "./routes/Listings";
import { ListingDetail } from "./routes/ListingDetail";
import { CriteriaPage } from "./routes/Criteria";
import { CriterionEdit } from "./routes/CriterionEdit";
import { Stats } from "./routes/Stats";

const rootRoute = createRootRoute({ component: Layout });

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: Listings,
  validateSearch: (search): {
    status?: string;
    source?: string;
    sort?: string;
    dir?: "asc" | "desc";
  } => ({
    status: typeof search.status === "string" ? search.status : undefined,
    source: typeof search.source === "string" ? search.source : undefined,
    sort: typeof search.sort === "string" ? search.sort : undefined,
    dir: search.dir === "asc" || search.dir === "desc" ? search.dir : undefined,
  }),
});

const listingDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/listings/$listingId",
  component: ListingDetail,
});

const criteriaIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/criteria",
  component: CriteriaPage,
});

const criterionEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/criteria/$criterionId/edit",
  component: CriterionEdit,
});

const statsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/stats",
  component: Stats,
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  listingDetailRoute,
  criteriaIndexRoute,
  criterionEditRoute,
  statsRoute,
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
